/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { BaseURL, fetchTimeout } from "../../components/Common";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { Palette, API_BASE } from "../../AppConfig";
import BSL_TextInput from "../../components/BSL_TextInput";
import BSL_Button from "../../components/BSL_Button";
import BSL_Select from "../../components/BSL_Select";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Message from "../../components/Message";
import Draggable from "react-draggable";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import FrameAppBar from "./FrameAppBar";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/appState";
import { updateJobParameter } from "../../redux_store/jobState";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles({
    root: {
        position: "fixed",
        width: "40%",
        minWidth: "500px",
        zIndex: "11000",
        background: "#e2e9efe6",
        bottom: "20px",
        left: "101px",
        border: "1px solid grey",
        backdropFilter: "blur(4px)",
        borderRadius: "3px",
        display: "flex",
        flexDirection: "column",
        padding: "10px",
    },
    attachmentLabel: {
        alignSelf: "center",
        fontSize: "10pt",
        flex: 1,
        textAlign: "start",
        display: "flex",
        flexDirection: "column",
    },
    attachmentItem: {
        background: "#fffff3",
        borderRadius: "14px",
        padding: "0px 10px",
        whiteSpace: "nowrap",
        margin: "2px",
        display: "flex",
        alignItems: "center",
    },
    deleteButton: {
        fontSize: "0.5rem",
        padding: "0px",
    },
});
function bytesToSize(bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes == 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

export default function MessageSupport(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const inputRef = React.useRef(null);
    const [attachedFileForUpload, setAttachedFileForUpload] = React.useState([]);
    const [sending, setSending] = React.useState(false);
    const [showMessage, setShowMessage] = React.useState(false);
    const user = useSelector((state) => state?.app?.user);
    const job = useSelector((state) => state?.job);

    const [messageText, setMessageText] = React.useState(props.defaultMessage ? props.defaultMessage : "");

    const config = useSelector((state) => state?.config);
    const ORDER_REVIEW = "Order Review";
    const mode = props?.mode;

    let default_to =
        '"' +
        config?.region?.name +
        '" <' +
        (window.debug ? "centsupport@qikquotecentenary.com" : config?.region?.support_email) +
        ">";

    if (mode === ORDER_REVIEW) {
        default_to =
            '"' +
            (job?.User?.DisplayName
                ? job?.User?.DisplayName
                : job?.User.FirstName + (job?.User.LastName ? " " + job?.User.LastName : "")) +
            '" <' +
            job?.User.Email +
            ">";
    }
    const [to, setTo] = React.useState(default_to);

    if (!job?.id) {
        return <></>;
    }

    let title = "Request Support from " + config?.region?.name;
    let send_button_text = "SEND REQUEST";
    let bg_colour = window.LYSAGHT ? Palette.Lysaght.DarkBlue : Palette.FieldersBlue;

    let cc =
        '"' +
        (user?.DisplayName ? user?.DisplayName : user.FirstName + (user.LastName ? " " + user.LastName : "")) +
        '" <' +
        user.Email +
        ">";

    //DES-1424 - enable email and pop up for special iteam delivery
    let subject = "";
    if (props.messageType === "FREIGHT POA") {
        subject = "Insulated Panel Delivery Charge Request for #" + job?.id + " (" + job?.Customer?.JobName + ")";
    } else {
        subject = "Support Request for #" + job?.id + " (" + job?.Customer?.JobName + ")";
    }

    if (mode === ORDER_REVIEW) {
        title = "Send Order Review";
        bg_colour = Palette.FieldersOrange;
        send_button_text = "SEND ORDER REVIEW";
        cc =
            '"' +
            config.region.name +
            '" <' +
            (window.debug ? "centsupport@qikquotecentenary.com" : config?.region?.support_email) +
            ">";
        subject = "Order Review for #" + job?.id + " (" + job?.Customer?.JobName + ")";
    }

    if (props.subject) {
        subject = props.subject;
    }

    const sendRequest = () => {
        if (messageText.length < 4) {
            setShowMessage({
                type: "warning",
                message: "Please write a short message to explain your support request.",
            });
            return;
        }

        setSending(true);

        let api_url = API_BASE() + "Message/";

        let attachments = [];
        let attachment_filenames = "";

        //add screenshot of paper

        let inline_attachments = [];
        try {
            var data = window.paper_canvas.toDataURL();

            // base64 encoded data doesn't contain commas
            let base64ContentArray = data.split(",");

            // base64 content cannot contain whitespaces but nevertheless skip if there are!
            let mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];

            // base64 encoded data - pure
            let base64Data = base64ContentArray[1];

            inline_attachments.push({
                "Content-type": mimeType,
                Filename: job.id + ".png",
                size: base64Data.length,
                content: base64Data,
            });
        } catch {}

        if (attachedFileForUpload) {
            attachments = [...attachedFileForUpload];
            let combined_size = 0;
            for (let item of attachments) {
                attachment_filenames +=
                    (attachment_filenames !== "" ? "<br />" : "") + item.Filename + " (" + bytesToSize(item.size) + ")";
                combined_size += item.size;
            }

            if (combined_size > 2096000 * 4) {
                setShowMessage({
                    type: "Error",
                    message: "Error: Attached files are too large. Max size overall = 8MB",
                });
                setSending(false);
                return;
            } else if (combined_size > 2096000 * 2) {
                setShowMessage({
                    type: "warning",
                    message: "uploading attachments...",
                });
            }
        }

        let html = "";

        if (mode === ORDER_REVIEW) {
            html = getOrderReviewTemplate();
        } else {
            html = getSupportRequestTemplate();
        }

        html =
            `<div style="
    font-size: 16px;
    color: #01507e;">` +
            messageText.replace(/(?:\r\n|\r|\n)/g, "<br>") +
            `</div><br />` +
            html;

        html = html.replace("$$_USERNAME_$$", user?.FirstName + (user?.LastName ? " " + user?.LastName : ""));
        html = html.replace("$$_PHONE_$$", user?.Phone);
        html = html.replace("$$_EMAIL_$$", user?.Email);
        html = html.replace("$$_BUSINESS_$$", user?.BusinessDetails.Name);
        html = html.replace("$$_JOB_ID_$$", job?.id + " (" + job?.Customer.JobName + ")");
        html = html.replaceAll("$$_JOB_URL_$$", window.location.origin + BaseURL() + "?job=" + job.id);
        html = html.replace(
            "$$_DESIGN_SUMMARY_$$",
            job?.DesignSummary +
                '<br /><img src="cid:' +
                job.id +
                '.png"  width="100%" style="background: white; width: 100%; max-width: 900px;"> '
        );
        html = html.replace("$$_MESSAGE_$$", messageText.replace(/(?:\r\n|\r|\n)/g, "<br>"));
        html = html.replace("$$_ATTACHMENTS_$$", attachment_filenames ? attachment_filenames : "None");

        fetchTimeout(
            api_url,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    FromEmail: window.LYSAGHT ? "no_reply@lysaght.com" : "no_reply@qikquotecentenary.com",
                    FromName: window.LYSAGHT
                        ? "Lysaght Living Designer (No Reply)"
                        : "Centenary Design Suite (No Reply)",
                    Subject: subject,
                    TextPart: messageText,
                    HtmlPart: html,
                    To: to,
                    CC: cc,
                    Attachments: attachments,
                    InlineAttachments: inline_attachments,
                    job: job,
                }),
            },
            60000
        )
            .then(async (response) => {
                if (response.status >= 200 && response.status <= 300) {
                    setShowMessage({
                        type: "Success",
                        message: "Success: Emails sent",
                    });
                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: {
                            type: "Success",
                            message: "Success: Emails sent",
                        },
                    });
                    setSending(false);
                    setMessageText("");
                    props.setShowMessageSupport(false);
                    if (mode === ORDER_REVIEW) {
                        dispatch(
                            updateJobParameter(null, {
                                OrderReviewMessage: messageText,
                                OrderStatus: "Reviewed",
                            })
                        );
                    }
                } else {
                    setShowMessage({
                        type: "error",
                        message: "Error sending support request. Please try again.",
                    });

                    setSending(false);
                }
            })
            .catch((e) => {
                setShowMessage({
                    type: "error",
                    message: "Possible Error sending support request. Please check your email to see if it was sent.",
                });
                setSending(false);
            });
    };

    const deleteAttachment = (index) => {
        let newattachedFileForUpload = [...attachedFileForUpload];
        newattachedFileForUpload.splice(index, 1);
        setAttachedFileForUpload(newattachedFileForUpload);
    };

    const uploadFile = (e) => {
        if (!inputRef?.current?.files) return;
        if (inputRef.current.files[0].size > 2096000 * 2) {
            setShowMessage({
                type: "warning",
                message: "Error: File is too large to attach. Max size = 4MB",
            });
            return;
        }

        var FR = new FileReader();

        FR.addEventListener("load", function (e2) {
            if (!inputRef?.current?.files) return;

            var data = e2.target.result;

            // base64 encoded data doesn't contain commas
            let base64ContentArray = data.split(",");

            // base64 content cannot contain whitespaces but nevertheless skip if there are!
            let mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];

            // base64 encoded data - pure
            let base64Data = base64ContentArray[1];

            let newattachedFileForUpload = [...attachedFileForUpload];
            newattachedFileForUpload.push({
                "Content-type": mimeType,
                Filename: inputRef.current.files[0].name,
                size: inputRef.current.files[0].size,
                content: base64Data,
            });
            setAttachedFileForUpload(newattachedFileForUpload);
            inputRef.current.value = "";
        });

        FR.readAsDataURL(e.target.files[0]);
    };

    return (
        <Draggable handle="#handle">
            <div className={classes.root} style={props.style}>
                <span id="handle" style={{ cursor: "grab" }}>
                    <FrameAppBar
                        title={
                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <DragIndicatorIcon style={{ alignSelf: "center" }} />
                                <span style={{ flex: 1 }}>{title}</span>
                            </div>
                        }
                        style={{ background: bg_colour }}
                        onClick={() => props.setShowMessageSupport(false)}
                    />
                </span>
                <BSL_Common.SectionSubHeader>
                    {user.Role >= 90 && (
                        <BSL_Common.SectionRow
                            style={{
                                alignItems: "center",
                            }}
                        >
                            <span
                                style={{
                                    font: '12pt "Univers45", sans-serif',
                                }}
                            >
                                <strong>to:</strong>
                            </span>{" "}
                            <BSL_Select
                                value={to}
                                tight={true}
                                items={
                                    user.Role >= 90
                                        ? [
                                              default_to,
                                              window.brand === "Lysaght"
                                                  ? '"BBC Tech Support" <bbcsoftwaresupport@bluescopesteel.com>'
                                                  : '"Tech Support" <centsupport@qikquotecentenary.com>',
                                          ]
                                        : [default_to, '"BBC Tech Support" <bbcsoftwaresupport@bluescopesteel.com>']
                                }
                                onChange={(e, v) => {
                                    setTo(e.target.value);
                                }}
                            />
                        </BSL_Common.SectionRow>
                    )}
                    {user.Role <= 90 && (
                        <>
                            <strong>to:</strong> {to}
                            <br />
                        </>
                    )}
                    <strong>cc:</strong> {cc}
                    <br />
                    <strong>subject:</strong> {subject}
                </BSL_Common.SectionSubHeader>
                <BSL_TextInput
                    multiline
                    tight
                    value={messageText}
                    rows={8}
                    style={{
                        height: "200px",
                        flex: 1,
                    }}
                    onBlur={(val) => {
                        setMessageText(val);
                    }}
                />

                <BSL_Common.SectionRow>
                    <input
                        ref={inputRef}
                        key={"input_x"}
                        accept=".pdf, .png, .jpg, .jpeg, .gif, .doc, .docx, .xls, .xlsx"
                        style={{ display: "none" }}
                        id="support_attachment"
                        multiple
                        type="file"
                        onChange={uploadFile}
                    />
                    <label htmlFor="support_attachment">
                        <BSL_Button
                            secondary
                            variant="contained"
                            component="span"
                            label={<AttachFileIcon />}
                            style={{
                                margin: "10px",
                            }}
                        />
                    </label>
                    <div className={classes.attachmentLabel}>
                        {attachedFileForUpload.map((item, index) => {
                            return (
                                <div className={classes.attachmentItem}>
                                    <span style={{ flex: 1 }}>
                                        {item.Filename + " (" + bytesToSize(item.size) + ")"}
                                    </span>
                                    <IconButton
                                        className={classes.deleteButton}
                                        onClick={() => deleteAttachment(index)}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            );
                        })}
                    </div>
                    <BSL_Button
                        variant="contained"
                        component="span"
                        label={sending ? <CircularProgress /> : send_button_text}
                        style={{
                            margin: "10px",
                            maxHeight: "42px",
                        }}
                        disabled={sending}
                        onClick={sendRequest}
                    />
                </BSL_Common.SectionRow>
                <Message
                    open={showMessage}
                    message={showMessage?.message}
                    type={showMessage?.type}
                    onClose={() => setShowMessage(null)}
                />
            </div>
        </Draggable>
    );
}

const getSupportRequestTemplate = () => {
    return `<h2 style="color: #2e6c80;"><span style="color: #000080;">Support Request Details</span></h2>
<p>A Support Request has been made by</p>
<table style="border-collapse: collapse; width: 100%" border="1" cellpadding="5px">
<tbody>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">USER NAME</td>
<td style="font-size: 10pt;">$$_USERNAME_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">PHONE / EMAIL</td>
<td style="font-size: 10pt;">$$_PHONE_$$ / $$_EMAIL_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">BUSINESS</td>
<td style="font-size: 10pt;">$$_BUSINESS_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">JOB ID / LINK</td>
<td style="font-size: 10pt;">$$_JOB_ID_$$<br /><a href="$$_JOB_URL_$$" target="_blank">$$_JOB_URL_$$</a></td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">DESIGN TYPE</td>
<td style="font-size: 10pt;">$$_DESIGN_SUMMARY_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">MESSAGE</td>
<td style="font-size: 10pt;">$$_MESSAGE_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ATTACHMENTS</td>
<td style="font-size: 10pt;">$$_ATTACHMENTS_$$</td>
</tr>
</tbody>
</table>
<p><span style="color: #999999;"><em>This email was sent from a no-reply email address, however this email has been CC'd to the requester, so you may "Reply All' to communicate directly via email with the requester.</em></span></p>`;
};

const getOrderReviewTemplate = () => {
    return `<h2 style="color: #2e6c80;"><span style="color: #806020;">${
        window.LYSAGHT ? "Lysaght Living Designer" : "Centenary Design Suite"
    } - Order Review Details</span></h2>
<p>A review has been made to your order: please make any necessary changes or contact ${
        window.LYSAGHT ? "Lysaght" : "Fielders"
    } for clarification.</p>
<table style="border-collapse: collapse; width: 100%" border="1" cellpadding="5px">
<tbody>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: #f6e6c5db;">JOB ID / LINK</td>
<td style="font-size: 10pt;">$$_JOB_ID_$$<br /><a href="$$_JOB_URL_$$" target="_blank">$$_JOB_URL_$$</a></td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: #f6e6c5db;">MESSAGE</td>
<td style="font-size: 10pt;">$$_MESSAGE_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: #f6e6c5db;">ATTACHMENTS</td>
<td style="font-size: 10pt;">$$_ATTACHMENTS_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: #f6e6c5db;">DESIGN TYPE</td>
<td style="font-size: 10pt;">$$_DESIGN_SUMMARY_$$</td>
</tr>
</tbody>
</table>
<p><span style="color: #999999;"><em>This email was sent from a no-reply email address, however this email has been CC'd to the sender, so you may "Reply All' to communicate directly via email with the sender.</em></span></p>`;
};
